var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/feed_unselected.5cb9c0cd.png","uri@2x": __webpack_public_path__ + "static/media/feed_unselected.ad1034d3.png","uri@3x": __webpack_public_path__ + "static/media/feed_unselected.b1e60dca.png",
    width: 24,
    height: 25
});